import { NgModule } from '@angular/core';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatToolbarModule,
  MatStepperModule,
  MatInputModule,
  MatFormFieldModule,
  MatOptionModule,
  MatSelectModule,
  MatGridListModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatIconModule,
  MatExpansionModule,
  MatCardModule,
  MatListModule,
  MatSlideToggleModule,
  MatDatepickerModule,
  MatNativeDateModule
} from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({

  exports: [
    MatButtonModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatStepperModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatIconModule,
    MatExpansionModule,
    MatCardModule,
    MatDialogModule,
    MatListModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule

  ],
})
export class MyOwnCustomMaterialModule { }


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/materialmodule.ts